<div class="dashboard-container" ref="ManualVerification">
    <div class="content-area">
      <h2 class="page-title fw-bold">Manual Verification</h2>
      <hr class="sidebar-hr fw-bold mb-4 mt-4 border-3 border-info opacity-75">

        <div class="container mt-3">
            <div class="d-flex">
                <a
                    class="text-dark px-4 py-2 rounded-top text-decoration-none me-3 border border-color border-bottom-0"
                    :class="{ 'active-file-tab': active_file_tab === 'employee' }"
                    @click="set_active_file_tab('employee')">
                    Customer
                </a>
                <a
                    class="text-dark px-4 py-2  rounded-top text-decoration-none me-3 border border-color border-bottom-0"
                    :class="{ 'active-file-tab': active_file_tab === 'trust_details' }"
                    @click="set_active_file_tab('trust_details')"
                >
                    Monitoring Details
                </a>
                <a
                    class="text-dark px-4 py-2 rounded-top text-decoration-none me-3 border border-color border-bottom-0"
                    :class="{ 'active-file-tab': active_file_tab === 'documents' }"
                    @click="set_active_file_tab('documents')"
                >
                    Documents
                </a>
            </div>

            <div class="p-3 rounded-bottom-4 shadow-sm border border-top-0 border-color">
                <div class=" text-white rounded-2 mb-3 p-1 d-flex justify-content-between align-items-center shadow custom-header ">
                    <!-- Left Scroll Button -->
                    <div class="ms-3 scroll-button" @click="scroll_left">
                        <i class="bi bi-chevron-left fs-5"></i>
                    </div>

                    <!-- Scrollable Tabs Container -->
                    <div class="tabs-container flex-grow-1 mx-2 overflow-hidden text-white" ref="tabsContainer">
                        <div class="tabs-wrapper d-flex">
                            <div
                                v-for="(tab, index) in active_section_tabs"
                                :key="index"
                                class="text-center tab-link me-4"
                                :class="{ active: active_section_tabs === tab.id }"
                                @click="set_active_section_tab(tab.id)"
                            >
                                {{ tab.label }}
                            </div>
                        </div>
                    </div>

                    <!-- Right Scroll Button -->
                    <div class="me-3 scroll-button" @click="scroll_right">
                        <i class="bi bi-chevron-right fs-5"></i>
                    </div>
                </div>

                <div v-for="(tab, index) in active_section_tabs" :key="index" :id="tab.id" class="tab-content p-5 border-color" :class="{ active: active_section_tab === tab.id }">
                    <div class="questions-grid">
                        <div class="questions-column">
                            <div v-for="(question, qIndex) in left_questions(tab.questions)" :key="qIndex" class="question-item">
                                <div class="question-label">{{ question.label }}</div>
                                <div class="question-answer p-1 mb-2">{{ question.answer }}</div>
                            </div>
                        </div>
                        <div class="vertical-divider"></div>
                        <div class="questions-column">
                            <div v-for="(question, qIndex) in right_questions(tab.questions)" :key="qIndex" class="question-item">
                                <div class="question-label">{{ question.label }}</div>
                                <div class="question-answer p-1 mb-2">{{ question.answer }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-4">
                    <button class="btn btn-primary-dark text-xxs me-2" @click="verify_manually">Verify</button>
                    <button class="btn btn-primary-dark text-xxs" data-bs-toggle="modal" data-bs-target="#request_information">Request Information</button>
                </div>
            </div>
      </div>
    </div>
</div>


  <!-- Request Information Modal -->
<teleport to="body">
    <div class="modal fade" id="request_information" tabindex="-1" aria-labelledby="request_information_label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-3">
            <div class="modal-header border-bottom-0">
            <p class="modal-title text-s" id="request_information_label">Request Information</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <hr class="modal-hrr mb-3">
            <div class="modal-body">
            <div class="form-group mb-3">
                <label for="notes" class="form-label">Notes</label>
                <textarea id="notes" v-model="request_name" class="form-control text-xs rounded-small p-2 shadow-sm" rows="4" placeholder=""></textarea>
                <small class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Please enter a section name</small>
                <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
            </div>
            </div>
            <hr class="modal-hrr mb-3">
            <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow-sm" @click="request_information">Request</button>
            </div>
        </div>
        </div>
    </div>
</teleport>
